module.exports = __webpack_public_path__ + "img/icon_map_dian_lixian.4845c2f3.svg";